module.exports = __webpack_public_path__ + "images/illustrations/illustration-rise-circle-left-81706a95f0c3d71fb4633539b10fb19f.webp";